class VariantPickerValue extends HTMLElement {
  url; variantId;
  static class = 'selected';
  
  connectedCallback() {
    this.url = this.dataset.url;
    this.variantId = this.dataset.variant;
  }
  
  getUrl = () => {
    return this.url;
  }

  getId = () => {
    return this.variantId;
  }
}
if(!customElements.get('variant-picker-value')) {
  customElements.define('variant-picker-value', VariantPickerValue);
}

class VariantPicker extends HTMLElement {
  variant;
  
  connectedCallback() {
    this.init();
  }
  
  init = () => {
    this.variant = JSON.parse(this.querySelector('script').innerText);
  }

  getVariant = () => {
    return this.variant;
  }
}
if(!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

class ColorGroup extends HTMLElement {
  links; plus; isOpen = false; max;
  static HIDDEN = 'd-none';

  connectedCallback() {
    this.links = this.querySelectorAll('a');
    this.plus = this.querySelector('[data-more]');
    this.max = parseInt(this.dataset.max);

    if(this.max > 0){
      this.close();
  
      this.plus.addEventListener('click', () => {
        this.toggle();
      });
    }
  }

  toggle = () => {
    if(this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open = () => {
    Array.from(this.links).forEach(element => {
      element.classList.remove(ColorGroup.HIDDEN);
    });
    this.plus.classList.add(ColorGroup.HIDDEN);
    this.isOpen = true;
  }

  close = () => {
    if(this.links.length <= this.max) {
      this.open();
    } else {
      this.links.forEach((element, index) => {
        if(index > this.max - 1) {
          element.classList.add(ColorGroup.HIDDEN);
        }
      });
      this.plus.classList.remove(ColorGroup.HIDDEN);
    }
    this.isOpen = false;
  }
}
if(!customElements.get('color-group')) {
  customElements.define('color-group', ColorGroup);
}